import { render, staticRenderFns } from "./LayoutReportFullWidth.vue?vue&type=template&id=dbe157ba&"
import script from "./LayoutReportFullWidth.vue?vue&type=script&lang=ts&"
export * from "./LayoutReportFullWidth.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutReportFullWidth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports